<template>
  <div class="container">

    <h3 class="notifiCate">Notifications</h3>

    <div v-for="n in notifications" class="tile tile-notification" :class="{hidden:n.hidden}">

      <div class="tile-icon">
        <router-link :to="'/users/' + n.aboutUser._id">
          <avatar :user="n.aboutUser" :key="n.aboutUser._id"></avatar>
        </router-link>
      </div>

      <div class="tile-content">
        <div class="tile-title">
          {{n.aboutUser.profile.corporate
          ? n.aboutUser.profile.business
          : n.aboutUser.profile.firstname + ' ' + n.aboutUser.profile.lastname}}
          <span style="font-size:0.8em;float:right;">{{new Date(n.date).toLocaleDateString('en-GB')}}</span>
        </div>
        <div class="tile-subtitle text-gray">{{n.content}}</div>
      </div>

      <div class="tile-action">
        <button @click="del(n)" class="btn btn-clear float-right"></button>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import avatar from '@/components/users/avatar'
import utils from '@/components/utils'

export default {
  name: 'notifications',
  mixins: [utils],
  components: {
    avatar
  },
  data () {
    return {
      notifications: null
    }
  },
  created () {
    this.getNotifications()
  },
  methods: {
    getNotifications () {
      axios.get('/api/notifications/user')
      .then(res => {
        if (res.status === 200) {
          this.notifications = res.data
        }
      })
      .catch(e => { console.log(e.response.data) })
    },
    del (n) {
      axios.post('/api/notifications/delete/' + n._id)
      .then(res => {
        if (res.status === 200) {
          this.$set(n, 'hidden', true)
          utils.methods.delay(500, () => {
            let index = this.notifications.indexOf(n)
            this.notifications.splice(index, 1)
          })
        }
      })
    }
  }
}
</script>

<style>
.tile-notification {
  border-bottom: .05rem solid #e7e9ed;
  border-radius: 0rem;
  margin: .7em 1em;
  transition: all .5s;
  padding: 0 0 .7em 0;
}
.hidden {
  opacity: 0;
}
.notifiCate {
  margin: 59px 0px 20px .7em
}
@media (max-width: 599px) { 
  .notifiCate {
    margin: 9px 0px 20px 0em
  }
  .tile-notification {
    margin: .7em 0em;
  }
}
</style>



// WEBPACK FOOTER //
// notifications.vue?35a1b46e